<template>
  <v-container>
    <v-row justify="center">
      <v-col cols=10>
        <keep-alive>
          <router-view />
        </keep-alive>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-icon v-for="index in [1,2,3,4]" :key="index" :color="index == step ? 'primary' : 'secondaryAccentElement'">mdi-circle-medium</v-icon>
    </v-row>
  </v-container>
</template>
<script>
export default {
  computed: {
    step() {
      return this.$route.meta.step
    },
  }
}
</script>